export enum ThirdPartyLogApplication {
  None = 'none',
  Securimate = 'securimate',
  Exiger = 'exiger',
  ICertis = 'iCertis',
  Portal = 'portal',
  Apollo = 'apollo',
}
